<template>
  <n-config-provider :theme="darkTheme">
    <router-view/>
  </n-config-provider>
</template>
<script>
import {defineComponent} from 'vue'
import {darkTheme, NConfigProvider} from 'naive-ui'

export default defineComponent({
  components: {NConfigProvider},
  setup() {
    return {
      darkTheme
    }
  }
})
</script>
<style>
:root {
  --bg-color: #101014;
  --primary-color: #63e2b7;
  --text-color: rgba(255, 255, 255, 0.9);
  --text-secondary: rgba(255, 255, 255, 0.6);
  --glass-bg: rgba(255, 255, 255, 0.05);
  --glass-border: rgba(255, 255, 255, 0.1);
  --glass-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-color);
  color: var(--text-color);
  background-image: 
    radial-gradient(circle at 15% 50%, rgba(99, 226, 183, 0.08), transparent 25%), 
    radial-gradient(circle at 85% 30%, rgba(160, 100, 255, 0.08), transparent 25%);
  min-height: 100vh;
}

/* Global Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #18181c; 
}

::-webkit-scrollbar-thumb {
  background: #333; 
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #444; 
}
</style>
